<template>
  <a
    class="ddose"
    :href="`${homepageUrl}daily-dose-gto/?ddose=${todaysDD.index + 1}`"
    target="_blank"
  >
    <div
      class="gw_box flex-1"
      style="--box-padding: 0"
    >
      <div class="gw_box gw_box_widget_title">
        {{ $t('daily_gto.title') }}

        <div
          class="mdi mdi-chevron-right clr-white ml-auto text-large line-height_1 pa-1 icon_btn csst csst_nm"
        >
          <div
            class="csst_content text-nowrap"
            style="left: -0.25em; transform: translate(-100%, 0)"
            v-html="$t('tooltips.take_quiz')"
          ></div>
        </div>
      </div>
      <div
        class="gw_box ddose_content"
        style="--box-padding: 1.125rem"
      >
        <div class="f-center">
          <div class="f-center clr-white mt-2">
            <Logo style="fill: currentColor; width: 2.375rem" />
          </div>

          <div class="ml-auto"></div>
        </div>
        <div
          class="text-large text-underline_hover weight_600 uppercase clr-primary mt-4 text-break-alls"
        >
          {{ todaysDD.title }}
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import Logo from '@/assets/logo.svg'
import ddoses from '@/assets/daily_dose.json'
import { getDate, getMonth } from 'date-fns'

export default {
  name: 'DDose',
  components: {
    Logo,
  },
  computed: {
    todaysDD() {
      return ddoses.find(dDose => {
        const today = new Date()
        const dDoseDate = new Date(dDose.date)
        return getDate(today) === getDate(dDoseDate) && getMonth(today) === getMonth(dDoseDate)
      })
    },
    homepageUrl() {
      const homepageUrl = `https://${window.location.hostname.replace('app.', '')}/`
      // const homepageUrl = `https://${window.location.hostname.replace('app.', '')}/${this.$i18n.locale}/`
      return homepageUrl
    },
  },
}
</script>
<style lang="scss" scoped>
@media (hover: hover) and (pointer: fine) {
  .ddose {
    &_content {
      z-index: 1;
      &::before {
        content: '';
        background: var(--clr-black-1-3);
        height: calc(100% - 1rem);
        width: calc(100% - 1rem);
        left: 0.5rem;
        top: 0.5rem;
        position: absolute;
        border-radius: 4px;
        overflow: hidden;
        z-index: 0;
        opacity: 0;
        z-index: -1;
        transition: opacity 0.2s ease;
      }
      &:hover {
        &::before {
          opacity: 1;
        }
      }
    }
  }
}
</style>
